module.exports = __webpack_public_path__ + "img/UTREDF-7.4d116639.jpg";